import { utilSetTimeout } from "./utils/setTimeout";
const Menu = () => {
    const domElements = {
        menuTrigger: document.querySelector(".js-menu-trigger"),
        menuIcon: document.querySelector(".js-menu-trigger-icon"),
        menu: document.querySelector(".js-menu"),
        menuText: document.querySelector(".js-menu-trigger-text"),
        menuItems: document.querySelectorAll(".js-mobile-item-trigger"),
    };
    let isActive = false;
    let isAnimating = false;
    if (!domElements.menuTrigger ||
        !domElements.menuIcon ||
        !domElements.menu ||
        !domElements.menuText ||
        !domElements.menuItems ||
        !domElements.menuItems.length)
        return;
    domElements.menuTrigger.addEventListener("click", () => {
        if (isAnimating)
            return;
        isActive = !isActive;
        isAnimating = true;
        domElements.menuTrigger.classList.toggle("is-active", isActive);
        domElements.menuIcon.classList.toggle("is-active", isActive);
        domElements.menu.classList.toggle("is-active", isActive);
        utilSetTimeout(() => {
            domElements.menuText.textContent = isActive ? "Close Menu" : "Menu";
        }, 200);
        utilSetTimeout(() => {
            isAnimating = false;
        }, 400);
    });
    domElements.menuItems.forEach((item) => {
        item.addEventListener("click", () => {
            const triggerIcon = item.querySelector(".js-mobile-item-trigger-icon");
            const subMenu = item.classList.contains("is-parent")
                ? item.parentElement.querySelector(".js-mobile-sub")
                : item.parentElement.parentElement.querySelector(".js-mobile-sub");
            if (!subMenu || !triggerIcon)
                return;
            if (item.classList.contains("is-active")) {
                subMenu.style.height = "0";
            }
            else {
                subMenu.style.height = "auto";
                const height = subMenu.scrollHeight;
                subMenu.style.height = "0";
                utilSetTimeout(() => {
                    subMenu.style.height = `${height}px`;
                }, 10);
            }
            triggerIcon.classList.toggle("is-active");
            item.classList.toggle("is-active");
        });
    });
};
export default Menu;
